import {
  faCircleDown,
  faDollar,
  faHandshake,
  faHouse,
  faWallet,
} from '@fortawesome/pro-regular-svg-icons';
import Sidebar, { type SidebarProps } from './sidebar';

const sidebarItems = [
  { to: '/dashboard/home', icon: faHouse, label: 'sidebar.dashboard' },
  {
    to: '/dashboard/sub-affiliates',
    icon: faHandshake,
    label: 'sidebar.subAffiliates',
  },
  {
    to: '/dashboard/commissions',
    icon: faDollar,
    label: 'sidebar.commissions',
  },
  {
    to: '/dashboard/wallet',
    icon: faWallet,
    label: 'sidebar.wallet',
  },
  {
    to: '/dashboard/downloads',
    icon: faCircleDown,
    label: 'sidebar.downloads',
  },
];

type SidebarWithItemsProps = Omit<SidebarProps, 'items'>;

export function SidebarWithItems({
  ...props
}: SidebarWithItemsProps): JSX.Element {
  return <Sidebar items={sidebarItems} {...props} />;
}
